import useMobile from 'src/hooks/useMobile'
import { GeneralHeaderText, SmallText, ColoredSpan, siteReview1, siteReview2, siteReview3 } from '../styles'
import { TestimonialSectionWrapper, Ridges, LeftSection, Testimonials, Review } from '../styles/TestimonialSection.styles'

const TestimonialSection = () => {
  const isMobile = useMobile()

  return (
    <TestimonialSectionWrapper>
      <Ridges />
      <LeftSection>
        <GeneralHeaderText style={{ lineHeight: '1', paddingBottom: '12px' }}>
          Taking You<br/>
          <ColoredSpan color='blue'>From Zero to Fluent!</ColoredSpan>
        </GeneralHeaderText>
        <SmallText isMobile={isMobile}>
          For over 25 years, Japanese From Zero! has been used by students all over the world to successfully learn Japanese.
        </SmallText>
      </LeftSection>
      <Testimonials>
        <Review src={siteReview1} alt='glowing review 1' />
        <Review src={siteReview2} alt='glowing review 2' style={{ justifySelf: 'end' }} />
        <Review src={siteReview3} alt='glowing review 3' />
      </Testimonials>
    </TestimonialSectionWrapper>
  )
}

export default TestimonialSection
